export default {
    navigation: {
        homeLabel: "Startseite",
        lessonsLabel: "Lektionen",
        aboutLabel: "Zutaten"
    },
    level: {
        levelListLabel: "Alle Level",
    },
    lessons: {
        startLessonLabel: "Anfangen",
        continueLessonLabel: "Weitermachen"
    },
    editor: {
        undoLabel: "Rückgängig",
        redoLabel: "Wiederholen",
        debugLogTypes: {
            levelDescription: "Level Anweisungen",
            gameOver: "Game Over",
            debugLog: "Debug"
        }
    },
    game: {
        startBtnLabel: "Spiel Starten",
        pauseBtnLabel: "Spiel anhalten",
        continueBtnLabel: "Spiel fortsetzen",
        stopBtnLabel: "Stoppen",
        stats: {
            instructionCounterLabel: "Anweisungen",
            blocksCounterLabel: "Blöcke"
        },
        modal: {
            title: "Sieg",
            okBtn: "Zum nächsten Level",
            cancelBtn: "Hier bleiben"
        },
        controls: {
            speedSliderLabel: "Geschwindigkeit"
        }
    }
};
